module.exports = __webpack_public_path__ + "img/52.73b9ead4.png";